<div fxLayout="column">
    <nb-card *ngIf="isLoadingLogs">
        <nb-card-header>
            Fetching Activity Logs
        </nb-card-header>
        <nb-card-body>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </nb-card-body>
    </nb-card>
    <nb-card *ngIf="logs.length > 0" [nbSpinner]="isLoadingLogs" nbSpinnerStatus="info">
        <nb-card-body>
            <div fxLayout="column" style="width: 100%;">
                <div fxLayout="row" style="width: 100%;">
                    <b style="margin-bottom: 30px;">Centralized Logging System for eGlu Console : </b>
                    <div fxFlex></div>
                    <span>Showing recent 1000 Log Entries</span>
                </div>
                <nb-list>
                    <nb-list-item *ngFor="let log of logs">
                    <div fxLayout="column" style="width: 100%;">
                        <div fxLayout="row" style="width: 100%;">
                            <b>{{log.doneBy}}</b>
                            <div fxFlex></div>
                            <span style="color: gray;font-weight: bold;">{{log.date}}</span>
                        </div>
                        <span [innerHTML]="log.message | safeHtml" style="margin-top: 5px;"></span>
                    </div>
                    </nb-list-item>
                </nb-list>
            </div>
        </nb-card-body>
    </nb-card>
</div>